import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
  unreadCount: 0,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
};

const studentNotificationSlice = createSlice({
  name: 'studentNotification',
  initialState,
  reducers: {
    // Set loading state
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    // Set error state
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },

    // Set notifications
    setNotifications: (state, action) => {
      const { notifications, pagination } = action.payload;
      state.notifications = notifications;
      state.pagination = pagination;
      state.loading = false;
      state.error = null;
    },

    // Append notifications (for infinite scroll)
    appendNotifications: (state, action) => {
      const { notifications, pagination } = action.payload;
      state.notifications = [...state.notifications, ...notifications];
      state.pagination = pagination;
      state.loading = false;
    },

    // Set unread count
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },

    // Decrement unread count
    decrementUnreadCount: (state) => {
      if (state.unreadCount > 0) {
        state.unreadCount -= 1;
      }
    },

    // Mark notification as read (update in list)
    markAsRead: (state, action) => {
      const notificationId = action.payload;
      const notification = state.notifications.find(n => n._id === notificationId);
      if (notification && !notification.isRead) {
        notification.isRead = true;
        notification.readAt = new Date().toISOString();
        if (state.unreadCount > 0) {
          state.unreadCount -= 1;
        }
      }
    },

    // Mark all as read
    markAllAsRead: (state) => {
      state.notifications.forEach(n => {
        if (!n.isRead) {
          n.isRead = true;
          n.readAt = new Date().toISOString();
        }
      });
      state.unreadCount = 0;
    },

    // Add new notification (for real-time updates)
    addNotification: (state, action) => {
      state.notifications.unshift(action.payload);
      state.unreadCount += 1;
      state.pagination.total += 1;
    },

    // Reset notifications
    resetNotifications: () => initialState,

    // Clear error
    clearError: (state) => {
      state.error = null;
    },
  },
});

// Export actions
export const {
  setLoading,
  setError,
  setNotifications,
  appendNotifications,
  setUnreadCount,
  decrementUnreadCount,
  markAsRead,
  markAllAsRead,
  addNotification,
  resetNotifications,
  clearError,
} = studentNotificationSlice.actions;

// Selectors
export const selectNotifications = (state) => state.studentNotification.notifications;
export const selectUnreadCount = (state) => state.studentNotification.unreadCount;
export const selectNotificationLoading = (state) => state.studentNotification.loading;
export const selectNotificationError = (state) => state.studentNotification.error;
export const selectNotificationPagination = (state) => state.studentNotification.pagination;

export default studentNotificationSlice.reducer;
